import '../output.css';

function Footer() {
    const browsePrivacy = () => {
        window.location.href = '/privacy'
    }
    return (

        <footer className="bg-white dark:bg-custom pt-6 pb-6 ads">

                <nav className="flex flex-wrap justify-center ">
                        <a onClick={() => browsePrivacy()} className="cursor-pointer tracking-wider text-xl leading-6 text-black dark:text-white hover:text-yellow-300">
                            Privacy Policy
                        </a>
                </nav>
        </footer>

    );
}

export default Footer;